import { render, staticRenderFns } from "./GroupFooter.vue?vue&type=template&id=c26096c0&scoped=true&"
import script from "./GroupFooter.vue?vue&type=script&lang=js&"
export * from "./GroupFooter.vue?vue&type=script&lang=js&"
import style0 from "./GroupFooter.vue?vue&type=style&index=0&id=c26096c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26096c0",
  null
  
)

export default component.exports